import { Spinner } from "@mylaunch/components/ui"

export function SpinnerFallback() {
  return (
    <div className="flex justify-center p-m">
      <Spinner className="size-spinner" />
    </div>
  )
}
